import React from 'react';
import { Link } from 'react-router';

import projects from './data/projects';
import services from './data/services';

const Footer = () => {
  const handleScroll = (event) => {
    // event.preventDefault();
    const targetId = event.currentTarget.getAttribute('href').split('#')[1];
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const today = new Date()
  return (
    <>
      <section className="bottom-section">
        <div className="image">
        </div>
        <div className="text">
          <p>WHY US?</p>
          <h2>We get it done</h2>
          <p>Every project comes with its own needs and challenges. Tell us your priorities, and we'll fill them to your satisfaction.</p>
          <br/>
          <p>renewengineeringwp@gmail.com</p>
          <a className="btn-secondary hollow" href="mailto:renewengineeringwp@gmail.com?subject=Website%20Inquiry" target="_blank">Email Us</a>
        </div>
      </section>
      <footer className="footer">
        <section className="info">
          <div className="col-1">
            <h2>Service Area</h2>
            <p>Kaysville, UT</p>
            <br/>
            <p>
              We proudly serve the <strong>Salt Lake Valley and surrounding areas</strong>, providing expert mechanical engineering, design, and automation solutions. With a commitment to precision, innovation, and efficiency, we help local industries optimize production and achieve engineering excellence.
            </p>
          </div>
          <div className="col-2">
            <h2>Services</h2>
            <ul>
              
              {services.map((service) => (
                <li key={service.id}>
                  <Link onClick={handleScroll} to={`/services#${service.sid}`}>{service.title}</Link>
                </li>  
              ))}

            </ul>
          </div>
          <div className="col-3">
            <h2>Projects</h2>
            <ul>
              {projects.map((project) => (
                <li key={project.id}>
                  <Link onClick={handleScroll} to={`/projects#${project.sid}`}>{project.title}</Link>
                </li>  
              ))}
            </ul>
          </div>

        </section>
        <div className="line"></div>
        <section className="legal"> 
          <span>
            <img className="logo" src="/images/logo-transparent.png"/>
          </span>
          <span>
            <p>
              All Rights Reserved | Renew Engineering &copy; {today.getFullYear()}
            </p>
          </span>
        </section>
      </footer>
    </>
  )
}

export default Footer